<div
  class="row summary-widget-container"
  data-intercom-target="summary-widget-container"
>
  @for (widget of allWidgets; track widget) {
    <div
      class="col-md col-xs general-widget"
      [attr.data-intercom-target]="'Widget_Container_' + widget.type"
    >
      <div
        class="kt-shadow {{
          selectedWidget === widget.type ? 'kt-bg-brand active' : ''
        }}"
        (click)="onWidgetClick(widget.type)"
      >
        <div class="kt-widget24">
          <div class="kt-widget24__details">
            <div class="kt-widget24__info">
              <h4 class="kt-widget24__title">{{ widget.title }}</h4>
              <span class="kt-widget24__desc"> {{ widget.description }} </span>
            </div>
            @if (!widget.disabled) {
              <span class="kt-widget24__stats" [ngClass]="widget.className">
                {{ widget.value }}
              </span>
            }
            @if (widget.disabled) {
              <div
                class="d-flex flex-column align-items-end kt-widget24__stats"
              >
                <img
                  class="protag-img mb-1"
                  src="/assets/media/icons/pro-tag.svg"
                  alt="Pro upgrade tag"
                />
                <div class="widget_block">0</div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>
